/*
 * GT product page - pack/box/unit quantity selector.
 * Mirrors the wholesale catalog selector, but instead of its own stepper it
 * drives Dawn's native product-page quantity input (the field that Add to Cart
 * submits). Selecting a tab sets that input's value/min/step to the tab amount
 * and fires a bubbling 'change' so the native +/- then steps by that amount and
 * any listeners (price-per-item, quantity rules) update. Event-delegated so it
 * keeps working after variant-change re-renders. No hardcoded strings.
 */
(function () {
  function num(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function applyAmount(wrap, amount) {
    var id = wrap.getAttribute('data-gt-input-id');
    var input = id ? document.getElementById(id) : null;
    // Persist the chosen selling unit for the cart (hidden _gt_step line-item property).
    var stepId = wrap.getAttribute('data-gt-step-id');
    var stepInput = stepId ? document.getElementById(stepId) : null;
    if (stepInput) stepInput.value = amount;
    if (!input) return;
    input.step = amount;
    input.min = amount;
    input.setAttribute('min', amount);
    input.dataset.min = amount;
    input.value = amount;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-gt-amount]');
    if (!tab) return;
    var wrap = tab.closest('[data-gt-pdp]');
    if (!wrap) return;

    var tabs = wrap.querySelectorAll('[data-gt-amount]');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('is-active');
      tabs[i].setAttribute('aria-pressed', 'false');
    }
    tab.classList.add('is-active');
    tab.setAttribute('aria-pressed', 'true');

    applyAmount(wrap, num(tab.getAttribute('data-gt-amount'), 1));
  });
})();
